import { render, staticRenderFns } from "./dedicatedMerchant.vue?vue&type=template&id=15af21a3&scoped=true"
import script from "./dedicatedMerchant.vue?vue&type=script&lang=ts"
export * from "./dedicatedMerchant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15af21a3",
  null
  
)

export default component.exports